import JobNotesCard from '@/components/JobNotesCard';
import * as Styles from './JobNotes.styles';

export type JobTopic = {
  title: string;
  id: string;
  notes: any[];
};

type JobNotesComponentProps = {
  topics: JobTopic[];
  onScrollTo: (elementId: string) => void;
  onAddNewTopic: () => void;
  onAddNewNote: () => void;
};

const JobNotesComponent = function ({
  onScrollTo,
  topics,
  onAddNewTopic,
  onAddNewNote,
}: JobNotesComponentProps): JSX.Element {
  const tableOfContents = topics.map((topic) => ({
    name: topic.title,
    id: topic.id,
    scrollTo: () => onScrollTo(topic.id),
  }));

  return (
    <div data-testid="job-details-page" className="tw-pt-4">
      <Styles.PageGrid>
        <Styles.Sidebar
          tableOfContentOptions={tableOfContents}
          onClickAddNew={onAddNewTopic}
          buttonLabel="+ New Topic"
          data-testid="job-sidebar"
        />

        <Styles.Content>
          {topics.map((topic) => {
            return <JobNotesCard key={topic.id} onAddNewNote={onAddNewNote} {...topic} />;
          })}
        </Styles.Content>
      </Styles.PageGrid>
    </div>
  );
};

export default JobNotesComponent;
